export default __webpack_public_path__ + "static/media/shot3.b62cd81a.jpg";